import { render } from "./IndependentInvoices.vue?vue&type=template&id=3efc3b9c&ts=true"
import script from "./IndependentInvoices.vue?vue&type=script&lang=ts"
export * from "./IndependentInvoices.vue?vue&type=script&lang=ts"

import "./IndependentInvoices.vue?vue&type=style&index=0&id=3efc3b9c&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__